import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Alert,
    AlertColor,
    AlertPropsVariantOverrides,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import { OverridableStringUnion } from '@mui/types';
import axios from 'axios';
import { HOLIDAY_STATUS } from "../../assets/data/holidayStatus";
import axiosInstance from "../../services/axios-instance";
import { HOLIDAYS_STATUS_URL } from "../../services/endpoints";
import { useState } from "react";
import { AllHolidaysInterface } from "../../interface/allHolidaysInterface";
import React from 'react';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    color: theme.palette.text.primary,
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    backgroundColor: theme.palette.table.rowOdd,
}));

interface CellNamesParams {
    cellOne: string;
    cellTwo: string;
    cellTree: string;
    cellFour: string;
    cellFive: string;
    cellSix: string;
    cellSeven: string;
    cellEight: string;
    cellNine: string;
}
interface HolidaysTableElementProps {
    data: AllHolidaysInterface[];
    cellNames: CellNamesParams;
    setAllHolidays: React.Dispatch<
        React.SetStateAction<AllHolidaysInterface[]>
    >;
  }

const HolidaysTableElement: React.FC<HolidaysTableElementProps> = ({data, cellNames, setAllHolidays}) => {
    const theme = useTheme();
    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState<AlertColor | undefined>("info");
    const [variant, setVariant] = useState<OverridableStringUnion<"standard" | "filled" | "outlined", AlertPropsVariantOverrides> | undefined>("filled");

    const handleStatusUpdate = async (id: number, status: number) => {
        try {
            await axiosInstance.put(HOLIDAYS_STATUS_URL(id), {
                status: status,
            });

            setAllHolidays((prevData: any[]) => {
                const updatedData = prevData.map((holiday) => {
                    if (holiday.id === id) {
                        return { ...holiday, status: status };
                    }
                    return holiday;
                });
                return updatedData;
            });
        } catch (error) {
            if(axios.isAxiosError(error)) {
                setSeverity("error");
                setVariant("filled");
                setAlertMessage(error.response?.data.message);
                window.scrollTo(0, 0);
            }
        }
    };

    const getBackgroundColor = (status: HOLIDAY_STATUS, type?: number) => {
        switch (status) {
            case HOLIDAY_STATUS.Pending:
                return theme.palette.holiday.pending;
            case HOLIDAY_STATUS.Approved:
                return type === 3 ? theme.palette.holiday.sickLeave : theme.palette.success.main;
            case HOLIDAY_STATUS.Declined:
                return theme.palette.holiday.rejected;
            default:
                return "";
        }
    };

  return (
    <TableContainer>
    {alertMessage != "" &&
    (<Alert onClick={()=>setAlertMessage("")} variant={variant} severity={severity}>{alertMessage}</Alert>)}
        <Table>
            <TableHead>
                <TableRow
                    sx={{
                        backgroundColor: "table.rowEven",
                    }}
                >
                    <StyledTableCell>
                        {cellNames.cellOne}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellTwo}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellTree}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellFour}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellFive}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellSix}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellSeven}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellEight}
                    </StyledTableCell>
                    <StyledTableCell>
                        {cellNames.cellNine}
                    </StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((row: AllHolidaysInterface) => (
                    <StyledTableRow key={row.id}>
                        <TableCell>{row.user.name}</TableCell>
                        <TableCell>{row.user.email}</TableCell>
                        <TableCell>{row.type_text}</TableCell>
                        <TableCell>{row.notes}</TableCell>
                        <TableCell>{row.from_date}</TableCell>
                        <TableCell>{row.to_date}</TableCell>
                        <TableCell
                            style={{
                                color: getBackgroundColor(row.status, row.type),
                                fontWeight: "bold",
                                textTransform: "uppercase",
                            }}
                        >
                            {HOLIDAY_STATUS[row.status]
                                ? HOLIDAY_STATUS[row.status]
                                : ""}
                        </TableCell>
                        <TableCell>
                            <Button
                                variant="outlined"
                                color="success"
                                sx={{
                                    borderWidth: "2px",
                                }}
                                onClick={() =>
                                    handleStatusUpdate(
                                        row.id,
                                        HOLIDAY_STATUS.Approved
                                    )
                                }
                                disabled={row.status == 1}
                            >
                                Accept
                            </Button>
                        </TableCell>
                        <TableCell>
                            <Button
                                variant="outlined"
                                color="error"
                                sx={{
                                    borderWidth: "2px",
                                }}
                                onClick={() =>
                                    handleStatusUpdate(
                                        row.id,
                                        HOLIDAY_STATUS.Declined
                                    )
                                }
                                disabled={row.status == 2}
                            >
                                Decline
                            </Button>
                        </TableCell>
                    </StyledTableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
  );
};

export default HolidaysTableElement;